var map = {
	"./Test.jpg": 9001,
	"./add.png": 8726,
	"./background.svg": 5892,
	"./calendar.png": 6605,
	"./cancel.png": 9685,
	"./check.png": 8840,
	"./choices.png": 1115,
	"./cross.png": 4377,
	"./down-chevron.png": 4513,
	"./email.png": 5319,
	"./lock.png": 307,
	"./login-background.png": 1917,
	"./logo-square-white.png": 2716,
	"./logo-square.png": 6103,
	"./logo-white.png": 6286,
	"./logo.png": 4427,
	"./pencil.png": 9804,
	"./recycling-bin.png": 5246,
	"./true-false.png": 1997,
	"./up-chevron.png": 2431,
	"./user.png": 4353,
	"./vote.png": 1972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;